import * as types from "../actions/constants";

const INITIAL_STATE = {
  list: [],
  notifications: 0,
  init: false,
  videoList: []
};
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.ADD_CHAT_NOTIFICATION:
      return { ...state, notifications: state.notifications + 1 };
    case types.CLEAN_CHAT_NOTIFICATIONS:
      return { ...state, notifications: 0 };

    case types.UPDATE_CHAT_LIST:
      let newChat = state.list.find(chat => chat._id === action.chatId);
      if (!newChat) {
        newChat = action.chat;
      }
      newChat.lastMessage = action.lastMessage;
      newChat.messages = newChat.messages ? newChat.messages : [];
      newChat.messages = [...newChat.messages, action.lastMessage];
      return {
        ...state,
        list: [
          newChat,
          ...state.list.filter(chat => chat._id !== action.chatId)
        ]
      };

    case types.UPDATE_CONSULT_STATUS:
      return {
        ...state,
        list: state.list.map(chat => {
          if (action.consultId !== chat.currentConsultId._id) return chat;
          return {
            ...chat,
            currentConsultId: {
              _id: chat.currentConsultId._id,
              status: action.newStatus
            }
          };
        })
      };

    //old
    case types.FETCH_CHATS:
      if (state.init) return state;
      return {
        ...state,
        list: action.payload.map(chat => ({
          ...chat,
          messages: [chat.lastMessage]
        })),
        init: true
      };

    case types.UPDATE_CHATS_WITH_CONTACT_DATA:
      return { ...state, list: action.payload };
    /* NEW MESSAGE */
    case types.UPDATE_CHAT_WITH_MESSAGES:
      const newList = state.list.map(chat => {
        if (chat.ref !== action.payload.chatRef) return chat;
        return {
          ...chat,
          messages: [...chat.messages, ...action.payload.messages]
        };
      });
      return { ...state, list: newList };
    case types.UPDATE_CHAT_LAST_MESSAGE:
      const newListWithMessages = state.list.map(chat => {
        if (chat.ref !== action.payload.chatRef) return chat;
        return {
          ...chat,
          data: {
            ...chat.data,
            last_message: action.payload.updates
          }
        };
      });
      return { ...state, list: newListWithMessages };
    case types.UPDATE_CHAT_DATA:
      const listWithNewData = state.list.map(chat => {
        if (chat.ref !== action.payload.chatRef) return chat;
        return {
          ...chat,
          data: action.payload.chatData
        };
      });
      return { ...state, list: listWithNewData };
    case types.FETCH_VIDEO_NOTIFICATIONS:
      console.log(action.payload);

      return { ...state, videoList: [action.payload, ...state.videoList] };

    case types.REMOVE_VIDEO_NOTIFICATION:
      const newVideoList = state.videoList.filter(video => {
        return video._id !== action.consultId;
      });
      return { ...state, videoList: newVideoList };
    default:
      return state;
  }
};
